
import loadJsonFromText from './loadJsonFromText';

export default function loadJsonFromUrl(url, callback) {
    let options = {
        method: 'GET',
        mode: 'cors'
    };

    fetch(new Request(url, options))
        .then(response => {
            return response.text();
        })
        .then(content => {
            loadJsonFromText(content, callback);
        })
        .catch(error => {
            console.error('fetch JSON failed:', error);
            callback(error);
        });
}
